import { CustomButton } from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { useConfiguration } from '@foxtrotplatform/platform-micro-site-core';
import { FunctionComponent, useCallback } from 'react';

import { CustomerSignupAppConfig } from '../../../index';

export const ApiSolutionButttons: FunctionComponent = () => {
  const { configuration } = useConfiguration();
  const { marketplaceUiUrl } = configuration as CustomerSignupAppConfig;

  const handleManageSubscriptionClick = useCallback(() => {
    window.open(marketplaceUiUrl);
  }, [marketplaceUiUrl]);

  return (
    <div className="flex flex-row items-center gap-x-4">
      <CustomButton
        actionType="primary"
        onClick={handleManageSubscriptionClick}
      >
        Manage Subscription
      </CustomButton>
    </div>
  );
};
